import React, {useEffect, useState} from "react";
import Navbar from "../menu/nav";
import LanguageSwitch from "./language";
import {DarkModeSwitch} from "react-toggle-dark-mode";
import {Link, useLocation} from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import {useTranslation} from "react-i18next";

function HeaderComponent (props){

    const _dateYear = new Date().getFullYear();
    const { t, i18n } = useTranslation()

    const [scroll, setScroll] = useState(false);

    //TODO: Зробить планіше при скролі https://codepen.io/piyushpd139/pen/zYpwwaP

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 700);
        });
    }, []);

    const location = useLocation();

    return (<header className={''}>

        <div className={`${scroll ? "fixed-top m-3" : ""} shadow-border-bottom bg-white- liquid-glass p-4 pt-1 pb-1 d-flex justify-content-between align-items-center`}>
            <div className="logo d-flex justify-content-center align-items-center">
                <Link to="/" className={'nav-link pt-2 pt-md-0'}>
                    <h2>
                        {/*TODO: fix*/}
                        Y.L.
                        {/*{location.pathname ?? ''}*/}
                    </h2>
                </Link>
            </div>
            <div className="menu d-none d-md-block">
                <nav>
                    <ul className={'nav'}>
                        <li className={''}>
                            <Link  to={'/work'} className={'nav-link text-secondary text-decoration-none'}>
                                {t('nav.work')}
                            </Link>
                        </li>
                        <li className={''}>
                            <Link to="/products" className={'nav-link text-secondary text-decoration-none'}> {t('nav.products')}</Link>
                        </li>
                        <li className={''}>
                            <Link to="/press" target={'_blank'} className={'nav-link text-secondary text-decoration-none'}> Press</Link>
                        </li>
                        <li className={''}>
                            <Link to="/about" target={'_blank'} className={'nav-link text-secondary text-decoration-none'}> {t('nav.about me')}</Link>
                        </li>
                        <li className={''}>
                            {/*https://yaroslav.lukyanchuk.com/links*/}
                            <Link to="/contacts" target={'_blank'} className={'nav-link text-secondary text-decoration-none'}> {t('nav.contacts')}</Link>
                        </li>
                    </ul>
                </nav>
            </div>
            <div className={'d-flex align-items-center'}>
                {/*<a href="https://t.me/YaroslavLukyanchuk" className={'nav-link m-1'}>*/}
                {/*    <FaIcons.FaTelegram />*/}
                {/*</a>*/}
                <LanguageSwitch color={!props.isDarkMode ? 'white' : ''} />
                <DarkModeSwitch
                    style={{margin: '3px'}}
                    checked={props.isDarkMode}
                    onChange={props.toggleDarkMode}
                    moonColor={"grey"}
                    sunColor={"#FFBF00"}
                    size={20}
                />
                <Navbar />
            </div>

        </div>

    </header>);
}

export default HeaderComponent;
